<div class="title-components">
  <h1>Historial de versiones</h1>
</div>

<div class="divider-butons-VH">
  <div (click)="ToggleModalHelp(true)" class="btn btn-icon-text-left">
    <span class="text">Ayuda</span><i class="fa-regular fa-circle-question"></i>
  </div>
</div>

<div class="container-global-components ConVH">
  <div class="Table-Lib Table-container-Global">
    <p-table
      #dt
      [value]="List_Histrory_Version_CCP"
      [(selection)]="SelectedList_Histrory_Version_CCP"
      dataKey="id"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 15, 25, 50]"
      [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [filterDelay]="0"
      [globalFilterFields]="[
        'Name',
        'Revision_No',
        'Model_Year',
        'Code',
        'Invoice_4M',
        'Reviewer_Name',
        'Approver_Name'
      ]"
    >
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">
            <!--?===== INPUT FOR HOE SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i
              ><input
                [(ngModel)]="Filter_VersionH"
                type="text"
                (input)="dt.filterGlobal(Filter_VersionH, 'contains')"
                placeholder="Buscar en historial de versiones"
              />
            </div>
          </div>
          <div class="right-CT"></div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let Header of HeadersVH">
            <ng-container *ngIf="Header.Key_Header === 'DOW'">
              <th class="{{ Header.Key_Header }}">{{ Header.Name }}</th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'NAM'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      type="text"
                      field="Name"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'NOR'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      type="text"
                      field="Revision_No"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'MOY'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      field="Model_Year"
                      matchMode="in"
                      display="menu"
                      [showMatchModes]="false"
                      [showOperator]="false"
                      [showAddButton]="false"
                      class="ml-auto"
                    >
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">MODEL</span>
                        </div>
                      </ng-template>
                      <ng-template
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-multiSelect
                          [ngModel]="value"
                          [options]="Filter_Global_Check.Model_Year"
                          placeholder="Seleccione"
                          (onChange)="filter($event.value)"
                        >
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{ option }}</span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'COD'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      type="text"
                      field="Code"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'INV'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      type="text"
                      field="Invoice_4M"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'CON'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      field="Contributor_Name"
                      matchMode="in"
                      display="menu"
                      [showMatchModes]="false"
                      [showOperator]="false"
                      [showAddButton]="false"
                      class="ml-auto"
                    >
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-multiSelect
                          [ngModel]="value"
                          [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione"
                          (onChange)="filter($event.value)"
                        >
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{ option }}</span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DAC'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      type="date"
                      field="Date_Created"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DEE'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      type="date"
                      field="Date_End"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'REV'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      field="Reviewer_Name"
                      matchMode="in"
                      display="menu"
                      [showMatchModes]="false"
                      [showOperator]="false"
                      [showAddButton]="false"
                      class="ml-auto"
                    >
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-multiSelect
                          [ngModel]="value"
                          [options]="Filter_Global_Check.Reviewer_Name"
                          placeholder="Seleccione"
                          (onChange)="filter($event.value)"
                        >
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{ option }}</span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'APP'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      field="Approver_Name"
                      matchMode="in"
                      display="menu"
                      [showMatchModes]="false"
                      [showOperator]="false"
                      [showAddButton]="false"
                      class="ml-auto"
                    >
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-multiSelect
                          [ngModel]="value"
                          [options]="Filter_Global_Check.Approver_Name"
                          placeholder="Seleccione"
                          (onChange)="filter($event.value)"
                        >
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{ option }}</span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'STA'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-columnFilter
                      field="Status"
                      matchMode="in"
                      display="menu"
                      [showMatchModes]="false"
                      [showOperator]="false"
                      [showAddButton]="false"
                      class="ml-auto"
                    >
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template
                        pTemplate="filter"
                        let-value
                        let-filter="filterCallback"
                      >
                        <p-multiSelect
                          [ngModel]="value"
                          [options]="Filter_Global_Check.Status"
                          placeholder="Seleccione"
                          (onChange)="filter($event.value)"
                        >
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option">
                                    <div *ngSwitchCase="1">Aprobada</div>
                                    <div *ngSwitchCase="2">Pendiente</div>
                                    <div *ngSwitchCase="3">Rechazada</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-List_Histrory_Version_CCP
        let-i="rowIndex"
      >
        <tr>
          <td *ngFor="let Header of HeadersVH">
            <ng-container *ngIf="Header.Key_Header === 'DOW'">
              <button
                (click)="Check_Version_CCP(List_Histrory_Version_CCP, i)"
                [disabled]="
                  !(
                    UserRoleIn([PermissionCCP.downloadVersionFlow]) ||
                    UserService.UserRoleGeneralIn([
                      RolesGeneral.AdministratorCCP
                    ])
                  )
                "
                class="Btn-Download-Local Btn-Download-Global"
                id="Btn-Download{{ i }}"
              >
                <div class="Content-Download">
                  <span
                    class="Progress-Bar-Task"
                    id="Progress-Bar-Task{{ i }}"
                  ></span>
                  <span class="Btn-Text" id="Text-Btn{{ i }}">{{
                    UserRoleIn([PermissionCCP.downloadVersionFlow]) ||
                    UserService.UserRoleGeneralIn([
                      RolesGeneral.AdministratorCCP
                    ])
                      ? "Descargar"
                      : "Sin Permisos"
                  }}</span>
                  <i
                    class="fa-solid fa-cloud-arrow-down"
                    id="Icon-Btn{{ i }}"
                  ></i>
                </div>
              </button>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'NAM'">
              {{ List_Histrory_Version_CCP.Name }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'NOR'">
              {{ List_Histrory_Version_CCP.Revision_No }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'MOY'">
              {{
                List_Histrory_Version_CCP.Model_Year === 0
                  ? "N/A"
                  : List_Histrory_Version_CCP.Model_Year
              }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'COD'">
              {{ List_Histrory_Version_CCP.Code }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'INV'">
              {{ List_Histrory_Version_CCP.Invoice_4M }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'CON'">
              {{ List_Histrory_Version_CCP.Contributor_Name }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DAC'">
              {{ DateFormat(List_Histrory_Version_CCP.Date_Created) }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DEE'">
              {{
                DateFormat_Approved(
                  List_Histrory_Version_CCP.Date_End,
                  List_Histrory_Version_CCP.Status
                )
              }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'REV'">
              <div class="Status-Task">
                <div (click)="seeApproverAdmin_Reviewer(List_Histrory_Version_CCP)"
                  (click)="SeeReason_Reviewer(List_Histrory_Version_CCP)"
                  class="Icon-Status Status{{
                    List_Histrory_Version_CCP.TaskReviewer.Status
                  }}"
                >
                  <div>
                    <i
                      class="fa-solid {{
                        Icons[List_Histrory_Version_CCP.TaskReviewer.Status - 1]
                          .Icon
                      }}"
                    ></i>
                  </div>
                  <span
                    *ngIf="
                      SeeToolTip_Rejected_Reviewer(List_Histrory_Version_CCP)
                    "
                    class="Tool-Tip"
                    >Ver razón de rechazo</span
                  >
                  <span
                    *ngIf="
                      SeeToolTip_Approved_Admin_Reviwer(
                        List_Histrory_Version_CCP
                      )
                    "
                    class="Tool-Tip"
                    >Ver usuario aprobador</span
                  >
                </div>
                <span class="Name">
                  {{ List_Histrory_Version_CCP.Reviewer_Name }}</span
                >
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'APP'">
              <div class="Status-Task">
                <div (click)="seeApproverAdmin_Approver(List_Histrory_Version_CCP)"
                  (click)="SeeReason_Approver(List_Histrory_Version_CCP)"
                  class="Icon-Status Status{{
                    List_Histrory_Version_CCP.TaskApprover.Status
                  }}"
                >
                  <div>
                    <i
                      class="fa-solid {{
                        Icons[List_Histrory_Version_CCP.TaskApprover.Status - 1]
                          .Icon
                      }}"
                    ></i>
                  </div>
                  <span
                    *ngIf="
                      SeeToolTip_Rejected_Approver(List_Histrory_Version_CCP)
                    "
                    class="Tool-Tip"
                    >Ver razón de rechazo</span
                  >
                  <span
                    *ngIf="
                      SeeToolTip_Approved_Admin_Approver(
                        List_Histrory_Version_CCP
                      )
                    "
                    class="Tool-Tip"
                    >Ver usuario aprobador</span
                  >
                </div>
                <span class="Name">
                  {{ List_Histrory_Version_CCP.Approver_Name }}</span
                >
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'STA'">
              <div class="ContainerStatus">
                <div
                  class="StatusTool S{{ List_Histrory_Version_CCP.Status }}"
                ></div>
                {{ Status_string(List_Histrory_Version_CCP.Status) }}
              </div>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!---===================== MODAL FOR HELP ICONS =====================--->
<section class="Modal-Global" id="ModalIconsHelp">
  <div class="wrapper">
    <div class="Local-M-Icon-Popup popup">
      <div class="Local-M-Icon-inside popup-inside">
        <div class="Local-M-Icon-backgrounds backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Local-M-Icon-content content">
        <div (click)="ToggleModalHelp(false)" class="Btn-Close">
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="Content-Top">
          <h2>Iconografía</h2>
        </div>

        <div class="Content-body">
          <div class="Info-Icons">
            <div class="Header grid-column-2">
              <div class="Icon-container">Icono</div>
              <div class="Description">Descripción</div>
            </div>
            <div
              *ngFor="let icon of Icons; let i = index"
              class="grid-column-2"
            >
              <div class="Icon-container">
                <div class="Icon-Status Status{{ i + 1 }}">
                  <div><i class="fa-solid {{ Icons[i].Icon }}"></i></div>
                </div>
              </div>
              <div class="Description">
                {{ icon.Description }}
              </div>
            </div>
          </div>
        </div>
        <div class="Local-M-Icon-Bottom Content-Bottom">
          <div (click)="ToggleModalHelp(false)" class="Btn-Close-Modal">
            <span>Cerrar</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
